import axios from "axios";
import config from "../config";

const BASE_URL = config.host + "/api/3/action";

// Get total Dataset
export const getDatasetCount = async () => {
    const res = await axios.get(`${BASE_URL}/package_search`);
    return res.data.result.count; // lebih efisien dari pada package_list
};

// Get all Organizations
export const getOrganizations = async () => {
    const res = await axios.get(`${BASE_URL}/organization_list`);
    return res.data.result; 
};

// Get all Groups (kategori)
export const getGroups = async () => {
    const res = await axios.get(`${BASE_URL}/group_list?all_fields=true`);
    return res.data.result;
};

// Get Datasets by pagination
export const getDatasets = async (page = 1, rows =12, orgName = null) => {
    try {
        const start = (page - 1) * rows;
        let url = `${BASE_URL}/package_search?start=${start}&rows=${rows}`;

        if (orgName) {
            url += `&fq=organization:${orgName}`;
        }

        const res = await axios.get(url);
        const result = res.data?.result;

        return {
            total: result?.count || 0,
            datasets: result?.results.map(pkg => ({
                name: pkg.name,
                title: pkg.title,
                author: pkg.author || pkg.organization?.title || "-",
                organization: pkg.organization,
                metadata_modified: pkg.metadata_modified,
                notes: pkg.resources,
                source: "CKAN"
            })) || []
        };
    } catch (error) {
        console.error("Error CKAN getDatasets:", error);
        return { total: 0, datasets: [] };
    }
};